/**
 * Portal Manta · Cálculo de similaridade · cosseno entre vetores
 * Função pura · usada no motor de matching do "Novo Estudo"
 */

export function cossenoVec(a, b) {
  if (!a || !b || a.length !== b.length) return 0;
  let dot = 0, na = 0, nb = 0;
  for (let i = 0; i < a.length; i++) {
    dot += a[i] * b[i];
    na += a[i] * a[i];
    nb += b[i] * b[i];
  }
  const denom = Math.sqrt(na) * Math.sqrt(nb);
  return denom > 0 ? dot / denom : 0;
}

export default cossenoVec;
